<template>
   <div class="auth-main">
      <div class="auth_div vivify  fadeIn">
         <div class="auth_brand">
            <a class="navbar-brand" href="#"><img src="@/assets/images/logo-256x256.png" width="150" class="d-inline-block mb-0"></a>
            <br>
            <span class="mt-0 mb-0 font-40 font-weight-bold">ACECE</span>
            <h6 class="mt-0 font-nova">Assessoria e Consultoria Espiritual Capelania Escolar</h6>                                           
         </div>
         <div class="cards">
            <div class="body">
               <form class="form-auth-small">
                  <div class="form-group c_form_group">
                     <label>Email</label>
                     <input type="email" class="form-control" placeholder="Digite seu email" v-model="usuario">
                  </div>
                  <div class="password-input form-group c_form_group" v-if="!recuperacao">
                     <label>Senha</label>
                     <input :type="showPassword ? 'text' : 'password'" class="form-control password-field" placeholder="Digite sua senha" v-model="senha" @keyup.enter="verificarLogin">
                     <span @click="toggleShowPassword" class="toggle-password">
                        <i v-if="showPassword" class="fas fa-eye"></i>
                        <i v-else class="fas fa-eye-slash"></i>
                     </span>
                  </div>
                  <div class="form-group clearfix">
                     <label class="fancy-checkbox element-left ml-1">
                        <input type="checkbox" v-model="manterConectado">
                        <span>Mantenha-me conectado</span>
                     </label>								
                  </div>
                
                  <button type="button" class="btn btn-secondary btn-lg btn-block rounded" @click="verificarLogin"><span class="font-weight-bold ">ENTRAR</span></button>
                 
               </form>
            </div>
         </div>
      </div>
      <div class="animate_lines">
         <div class="line"></div>
         <div class="line"></div>
         <div class="line"></div>
         <div class="line"></div>
         <div class="line"></div>
         <div class="line"></div>
      </div>
    </div>
</template>

<script>

import Swal from 'sweetalert2'
import { mapState } from 'vuex'

export default {
	name: 'Login',
   data: function() {
		return {
			showPassword: false,
			usuario: '',
         senha: '',
         manterConectado: false,
         recuperacao: false
		}
	},
   computed: {
		... mapState({
         urlRest: state => state.urlRest
		})
	},
   methods: {
		verificarLogin : function () {
         if (this.usuario.trim().length > 0 && this.senha.trim().length > 0) {
            this.$store.dispatch('verificarCredenciais', {'usuario': this.usuario.trim(), 'senha': this.senha.trim(), 'manterConectado': this.manterConectado});
         }
		},
      toggleShowPassword() {
			this.showPassword = !this.showPassword;
		},
      resetPassword : function () {
         if (this.usuario.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Email inválido!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'post',
            url: this.urlRest +'usuarios/resetPassword',
				params: {
               email: this.usuario.trim()
            }
         }).then(function () {
            ref.recuperacao = false;

            Swal.fire({
               icon: 'success',
               title: 'Email de recuperação enviado!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               ref.$toast.fire({
                  icon: 'error',
                  title: 'Erro: ' + error.response.status
               })
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      }
	}
}

</script>